import { render, staticRenderFns } from "./ExternalLinkDialog.vue?vue&type=template&id=2a9b330e"
import script from "./ExternalLinkDialog.vue?vue&type=script&lang=js"
export * from "./ExternalLinkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports